import React from 'react'

interface ModuleStatusBadgeProps {
  isDraft: boolean
  size?: 'sm' | 'md'
}

export const ModuleStatusBadge: React.FC<ModuleStatusBadgeProps> = ({ isDraft, size = 'sm' }) => {
  const sizeClasses = size === 'sm'
    ? 'px-2.5 py-1 text-xs'
    : 'px-3 py-1.5 text-sm'

  if (isDraft) {
    return (
      <span className={`inline-flex items-center gap-1 ${sizeClasses} rounded-lg font-black tracking-widest bg-amber-500/10 text-amber-500 border border-amber-500/20`}>
        <span className="material-symbols-outlined text-[14px]">edit_note</span>
        Draft
      </span>
    )
  }

  return (
    <span className={`inline-flex items-center gap-1 ${sizeClasses} rounded-lg font-black tracking-widest bg-emerald-500/10 text-emerald-500 border border-emerald-500/20`}>
      <span className="material-symbols-outlined text-[14px]">check_circle</span>
      Published
    </span>
  )
}

export default ModuleStatusBadge
